import { X, Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

export const CrossSellPopup = ({ product, onClose }) => {
  const { addToCart } = useCart();

  if (!product) return null;

  const handleAdd = () => {
    addToCart(product);
    toast.success(`${product.name} added to cart`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="cross-sell-popup">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#0A0A0A] border border-[#D4AF37] rounded-lg w-full max-w-[300px] shadow-2xl animate-fade-in-up overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#C41E3A] via-[#D4AF37] to-[#C41E3A]" />
        <button
          onClick={onClose}
          className="absolute top-2 right-2 z-10 text-gray-500 hover:text-white transition-colors"
          data-testid="cross-sell-close"
        >
          <X size={16} />
        </button>

        <div className="p-5">
          <div className="text-center mb-4">
            <p className="text-gray-300 text-xs leading-relaxed px-1">SNAP-8 requires Hyaluronic Acid Serum. Would you like to add this to your cart?</p>
          </div>

          <div className="flex items-center gap-3 mb-4 bg-[#121212] border border-[#27272A] rounded-sm p-2">
            <div className="w-14 h-14 flex-shrink-0 rounded-sm overflow-hidden">
              <img src={product.image} alt={product.name} className="w-full h-full object-contain" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-['Oswald'] text-white text-xs uppercase tracking-wide truncate">{product.name}</p>
              <p className="text-[#D4AF37] text-[10px]">{product.dosage}</p>
              <p className="text-[#C41E3A] text-sm font-bold">{product.price}</p>
            </div>
          </div>

          <div className="flex gap-2">
            <button
              onClick={handleAdd}
              className="flex-1 flex items-center justify-center gap-1 bg-[#C41E3A] hover:bg-[#A01830] text-white text-xs font-bold uppercase tracking-wider py-2.5 rounded-sm transition-all duration-300"
              data-testid="cross-sell-add-btn"
            >
              <Plus size={14} /> Add It
            </button>
            <button
              onClick={onClose}
              className="flex-1 border border-[#27272A] hover:border-[#C41E3A] text-gray-400 hover:text-white text-xs font-semibold uppercase tracking-wider py-2.5 rounded-sm transition-all duration-300"
              data-testid="cross-sell-skip-btn"
            >
              No Thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrossSellPopup;
